import { BouSpinnerSize } from '@upright/ui/common/generic/components/progress/spinners/bou-spinner';
import { CenteredSpinner } from '@upright/ui/common/generic/components/progress/spinners/centered-spinner';
import { BouPageWithFrame } from '@upright/ui/common/generic/layout/bou-tool-page-with-frame';
import MainNavigation from '@upright/ui/views/home-views/organizations-assets-view/main-navigation';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { HomeViewFrameOutletContext, useBuildHomeViewFrameOutletContext } from './context';
import { SelectedOrganizationProvider, useBuildSelectedOrganization } from './selected-organization-context';

export const HomeViewFrame = (props: { suspended?: boolean }) => {
  const context: HomeViewFrameOutletContext = useBuildHomeViewFrameOutletContext();
  const selectedOrganizationContext = useBuildSelectedOrganization();

  return (
    <SelectedOrganizationProvider value={selectedOrganizationContext}>
      <BouPageWithFrame sideBarContent={<MainNavigation />} hasTitleBar={false}>
        {props.suspended ? (
          <SpinnerWrap>
            <CenteredSpinner size={BouSpinnerSize.MEDIUM} />
          </SpinnerWrap>
        ) : (
          <Outlet context={context} />
        )}
      </BouPageWithFrame>
    </SelectedOrganizationProvider>
  );
};

const SpinnerWrap = styled.div`
  margin-top: 15em;
`;
